<template>
  <div class="card">
    <form @submit.prevent="buscar">
      <div class="p-fluid formgrid grid p-2">
        <div class="field col-12 md:col-6">
          <Dropdown
            v-model="mes"
            :options="meses"
            optionValue="code"
            optionLabel="name"
            placeholder="Selecione o Mês"
          />
        </div>
        <div class="field col-12 md:col-2">
          <InputText
            v-model="ano"
            placeholder="Digite o Ano"
            required="true"
            type="number"
          />
        </div>
        <div class="field col-12 md:col-2">
          <Button
            label="Buscar"
            icon="pi pi-search"
            class="button-secondary"
            type="submit"
          />
        </div>
        <div class="field col-12 md:col-2">
          <Button
            label="Data atual"
            icon="pi pi-calendar-times"
            class="button-secondary"
            type="button"
            @click="ajustarDataAtual"
          />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mes: null,
      ano: null,
      meses: [
        { name: "Janeiro", code: 1 },
        { name: "Fevereiro", code: 2 },
        { name: "Março", code: 3 },
        { name: "Abril", code: 4 },
        { name: "Maio", code: 5 },
        { name: "Junho", code: 6 },
        { name: "Julho", code: 7 },
        { name: "Agosto", code: 8 },
        { name: "Setembro", code: 9 },
        { name: "Outubro", code: 10 },
        { name: "Novembro", code: 11 },
        { name: "Dezembro", code: 12 },
      ],
    };
  },
  created() {
    this.ajustarDataAtual();
  },
  methods: {
    ajustarDataAtual() {
      this.mes = new Date().getMonth() + 1;
      this.ano = new Date().getFullYear();
    },
    buscar() {
      this.$emit("buscar", this.mes, this.ano);
    },
  },
};
</script>
